import { lazy, Suspense, useEffect, useRef } from 'react';
import { useTranslator } from '@eo-locale/react';
import { styled } from '@guest-widgets/core';
import { classes } from '@guest-widgets/shared/src/classes';
import { Feature } from '@guest-widgets/shared/src/features';
import { useFeature } from '@guest-widgets/shared/src/contexts/featureContext/featureContext';
import { TrackingEventType } from '@guest-widgets/shared/src/utils/customerTracking/types';
import { handleTrackingEvent } from '@guest-widgets/shared/src/utils/customerTracking/utils/trackingEventsHandler';

import { Products } from './Products';
import { FiltersSkeleton } from './Filters/FiltersSkeleton';
const Filters = lazy(() => import('./Filters/Filters'));
const BackToTop = lazy(() => import('./BackToTop'));
const Pagination = lazy(() => import('./Pagination'));

export const Catalog = () => {
  const containerEl = useRef<HTMLDivElement>(null);
  const { translate } = useTranslator();
  const { isEnabled } = useFeature();

  useEffect(() => {
    if (translate('product-catalog.title') !== 'product-catalog.title') {
      handleTrackingEvent(TrackingEventType.PAGE_VIEW, {
        title: translate('product-catalog.title'),
      });
    }
  }, [translate('product-catalog.title')]);

  return (
    <Container ref={containerEl} className={classes.catalog.root}>
      <HeaderWrapper>
        <Suspense fallback={<FiltersSkeleton />}>
          <Filters />
        </Suspense>
      </HeaderWrapper>
      <Products />
      <Suspense fallback={null}>
        <Pagination />
        {isEnabled(Feature.BackToTop) && <BackToTop containerEl={containerEl} />}
      </Suspense>
    </Container>
  );
};

export const Container = styled('div')(({ theme, widgetArea }) => ({
  padding: theme.spacing(widgetArea.basedOnSize(6, 8, 10)),
  position: 'relative',
  backgroundColor: theme.palette.background.paper,
}));

const HeaderWrapper = styled('div')(({ theme, widgetArea }) => ({
  marginBottom: theme.spacing(5),
  ...(widgetArea.isLarge
    ? {}
    : {
        alignItems: 'center',
      }),
}));
